import React, { Fragment, useState } from "react";
import Fade from "react-reveal/Fade";
import Flip from "react-reveal/Flip";
import { Articles } from "../../Data/Data";
import { Link } from "react-router-dom";

function AnnouncementBanner() {
  const [display, setDisplay] = useState(12);
  const handleViewMore = () => {
    if (display < Articles.length) {
      setDisplay((prevCount) => prevCount + 12);
    }
  }

  const handleViewLess = () => {
    if (display >= Articles.length || display > 12) {
      setDisplay((prevCount) => prevCount - 12);
    }
  }

  return (
    <Fragment>
      <div className="container governancemain motor">
        <div className="row arrticleAndBlogs">
          <div className="col-sm-12 heads govbanner blogs">
            <Fade up delay={500}>
              <h2 className="oswald">Articles And Blogs</h2>
            </Fade>
          </div>

          <div className="col-sm-12 heads text news blogers">
            <div className="row ArticlesAndBlogs">
              {Articles?.slice(0, display)?.map((data) => {
                // Trimming the content to 30 words
                const trimmedContent = data?.content.split(" ").slice(0, 25).join(" ") + (data.content.split(" ").length > 25 ? "..." : "");

                return (
                  <div className="col-sm-4" key={data.Key}>
                    <Fade right delay={500}>
                      <Link
                        to={`/articles-and-blogs/${data.Key}`}
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                          });
                        }}
                      >
                        <div className="menusildes">
                          <Flip top delay={500}>
                            <img src={data.feature} alt="" />
                          </Flip>
                          <Fade up delay={500}>
                            <p>{trimmedContent}</p>
                          </Fade>
                        </div>
                      </Link>
                    </Fade>
                  </div>
                );
              })}

              <div className="col-sm-12 viewMoreLess">
                {display < Articles.length && ( // Show "View More" only if there are more items to display
                  <button className="btn btn-primary" onClick={handleViewMore}>
                    View More
                  </button>
                )}
                {(display >= Articles.length && display > 12) && ( // Show "View More" only if there are more items to display
                  <button className="btn btn-primary" onClick={handleViewLess}>
                    View Less
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default AnnouncementBanner;
